/**
 * SafePassword 파일 처리 (순환 참조 방지를 위해 파싱/검증만 수행)
 * processImportData, showDecryptModal 호출은 bulkImport.js의 openImportFileWithSource에서 처리
 */
import { isSafeboxBackup } from '../externalImport'

/**
 * SafePassword 파일을 파싱하고 타입을 판별
 * @returns {{ type: 'encrypted'|'backup'|'error', data?: any }}
 */
const parseSafePasswordFile = (text) => {
  let importData = null
  try {
    importData = JSON.parse(text)
  } catch {
    return { type: 'error' }
  }

  if (!importData) {
    return { type: 'error' }
  }

  if (importData.encrypted === true) {
    return { type: 'encrypted', data: importData }
  }

  if (isSafeboxBackup(importData)) {
    return { type: 'backup', data: importData }
  }

  return { type: 'error' }
}

export default parseSafePasswordFile
